import { render, staticRenderFns } from "./MetricItem.vue?vue&type=template&id=16de823d&scoped=true&"
import script from "./MetricItem.vue?vue&type=script&lang=js&"
export * from "./MetricItem.vue?vue&type=script&lang=js&"
import style0 from "./MetricItem.vue?vue&type=style&index=0&id=16de823d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16de823d",
  null
  
)

export default component.exports